import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { Ticket } from "@app/models/rest/ticket";
import { TicketRestService } from "@app/services/hal/ticket-rest.service";
import { TicketUpdateSource } from "@app/models/enums/ticket-update-source.enum";
import { ResourceAvailability } from "@app/models/rest/resource-availability";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class TicketStore extends RealTimeDataStore<Ticket> {
  constructor() {
    const ticketRestService = inject(TicketRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(ticketRestService, webStompSubscriber, hateoasResourceService);
    // super.subscribeToMessaging('Ticket');
  }

  public deleteTicketAllocation(ticket: Ticket) {
    this.loadSingle(ticket.id).then((stored: Ticket) => {
      stored.lastUpdateSource = TicketUpdateSource.WebApi;
      this.update(stored).subscribe((updatedTicket: Ticket) => {
        updatedTicket
          .getRelation<ResourceAvailability>("resourceAvailability")
          .subscribe((availability) => {
            updatedTicket
              .deleteRelation("resourceAvailability", availability)
              .subscribe(() => {});
          });
      });
    });
  }

  public findByResourceAvailability(resourceAvailabilityId: number) {
    return this.loadWithSearch(
      "findByResourceAvailability",
      {
        params: {
          resourceAvailabilityId: resourceAvailabilityId,
          projection: "detail"
        }
      },
      true
    );
  }
}
